import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserDataService } from '@com-delta-idp/mnx-oauth';
import {
  AlternateFlow,
  NextgenReshopHeader,
  TripData
} from '../../model/global-nav.interfaces';

@Component({
  selector: 'ngc-my-trips-link',
  templateUrl: './my-trips-link.component.html'
})
export class MyTripsLinkComponent implements OnInit {
  @ViewChild('findTripForm') myTripsSearchForm: ElementRef;
  @Input() findTripData: TripData = {} as TripData;
  @Input() alternateFlow: AlternateFlow = {} as AlternateFlow;
  @Input() alternativeText: string;
  @Input() nextgenReshopHeaderData: NextgenReshopHeader =
    {} as NextgenReshopHeader;

  @Output() redirectback = new EventEmitter();

  //TODO: Uncomment below when all components stop sending findTripData as Input
  // findTripData: TripData = {} as TripData;
  TRIP_RETURN_ACTION = '/mytrips/';
  TRIP_ORIGINAL_SOURCE = 'Find+My+Trips';

  constructor(
    private activatedRoute: ActivatedRoute,
    private userData: UserDataService
  ) {}

  ngOnInit(): void {
    if (!this.findTripData || !this.findTripData.confirmationNo) {
      this.fetchPnrData();
    }
  }

  submitTripsForm() {
    if (this.alternateFlow?.redirectback) {
      this.redirectback.emit(true);
    } else {
      this.userData.getAuthConfigContent().subscribe((response) => {
        if (response?.NEXT_GEN_MY_TRIPS) {
          if (
            this.findTripData?.confirmationNo &&
            this.findTripData?.firstName &&
            this.findTripData?.lastName
          ) {
            sessionStorage.setItem(
              'trip_request',
              JSON.stringify({
                recordLocator: this.findTripData.confirmationNo,
                firstName: this.findTripData.firstName,
                lastName: this.findTripData.lastName,
                searchType: 'confirmationNo'
              })
            );
            window.location.href = response?.NEXT_GEN_MY_TRIPS_URL
              ? response.NEXT_GEN_MY_TRIPS_URL
              : '/my-trips/trip-details';
          } else {
            window.location.href = response?.NEXT_GEN_MY_TRIPS_URL
              ? response.NEXT_GEN_MY_TRIPS_URL
              : '/my-trips/trip-details';
          }
        } else {
          this.myTripsSearchForm.nativeElement.submit();
        }
      });
    }
  }

  fetchPnrData() {
    const cacheKeySuffix =
      this.activatedRoute.snapshot.queryParams.cacheKeySuffix;
    const pnrDataString =
      sessionStorage.getItem(`pnrData${cacheKeySuffix}`) !== null
        ? sessionStorage.getItem(`pnrData${cacheKeySuffix}`)
        : localStorage.getItem(`pnrData${cacheKeySuffix}`);
    if (pnrDataString) {
      const pnrData = JSON.parse(pnrDataString);
      this.findTripData = {
        firstName: pnrData.firstName,
        lastName: pnrData.lastName,
        confirmationNo: pnrData.recordLocatorId,
        returnAction: this.TRIP_RETURN_ACTION,
        originalSource: this.TRIP_ORIGINAL_SOURCE,
        interstitial: true
      };
    }
  }
}
